import React, { Component } from 'react'
import PropTypes from 'prop-types'

export default function(WrappedComponent) {
  class Container extends Component {
    static displayName = 'MainModuleRugsRowContainer'

    static propTypes = {
      recent: PropTypes.array.isRequired,
      recentMarkedForDesigners: PropTypes.array.isRequired,
      recentOrders: PropTypes.array.isRequired,
      setCurrentIndex: PropTypes.func.isRequired,
      togglePreview: PropTypes.func.isRequired,
      user: PropTypes.object.isRequired,
    }

    handleTogglePreviewRecent = () => {
      const { togglePreview } = this.props

      togglePreview('recent')
    }

    handleTogglePreviewRecentMFD = () => {
      const { togglePreview } = this.props

      togglePreview('recentMFD')
    }

    handleTogglePreviewRecentOrders = () => {
      const { togglePreview } = this.props

      togglePreview('recentOrders')
    }

    render() {
      return (
        <WrappedComponent
          togglePreviewRecent={this.handleTogglePreviewRecent}
          togglePreviewRecentMFD={this.handleTogglePreviewRecentMFD}
          togglePreviewRecentOrders={this.handleTogglePreviewRecentOrders}
          {...this.props}
        />
      )
    }
  }

  return Container
}
